import React from 'react';

import { Spinner } from 'baseui/spinner';

export const PageLoader = () => (
  <div className=" fixed left-0 top-0 z-[100] flex h-[100vh] w-[100vw] items-center justify-center bg-black bg-opacity-50">
    <Spinner size={90} color={'#E028DD'} />
  </div>
);
